<template>
  <div class="">
    <el-table :data="freeInfo.money_list" border size="small" :span-method="spanMethod">
      <el-table-column :label="$t('order.free.select')" width="55">
        <template slot-scope="scope">
          <el-radio
            v-model="currentRow"
            :label="scope.row"
            class="hidden-label-radio"
            v-if="Number(scope.row.all_money) > 0 && scope.row.msg != $t('order.free.serviceNotSupport')"
          ></el-radio>
        </template>
      </el-table-column>
      <el-table-column type="index" :label="$t('order.free.serialNo')" width="50"></el-table-column>
      <el-table-column prop="service_name" :label="$t('order.free.logisticsProduct')" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.msg != $t('order.free.serviceNotSupport') ? scope.row.service_name : $t('order.free.serviceNotSupport') }}</span>
          <el-popover
            v-if="isFailedRow(scope.row)"
            placement="top-start"
            trigger="hover"
            width="340"
            popper-class="free-fail-popover"
          >
            <div class="free-fail-title">{{ $t('order.free.failReason') }}</div>
            <div class="free-fail-content">{{ scope.row.msg }}</div>
            <i
              slot="reference"
              class="el-icon-warning free-fail-icon"
              :title="$t('order.free.failReasonTip')"
            ></i>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="all_money" :label="$t('order.free.totalFreight')" show-overflow-tooltip width="90">
        <template slot-scope="scope">
          {{ fmtMoney(scope.row.all_money) }}
        </template>
      </el-table-column>
      <el-table-column prop="fuel_money" :label="$t('order.free.fuelSurcharge')" show-overflow-tooltip width="60">
        <template slot-scope="scope">
          {{ fmtMoney(scope.row.fuel_money) }}
        </template>
      </el-table-column>
      <el-table-column prop="insurance_money" :label="$t('order.free.insuranceFee')" show-overflow-tooltip width="60">
        <template slot-scope="scope">
          {{ fmtMoney(scope.row.insurance_money) }}
        </template>
      </el-table-column>
      <el-table-column prop="weight" :label="$t('order.free.weight')" show-overflow-tooltip width="70"></el-table-column>
      <el-table-column prop="delivery_date" :label="$t('order.free.deliveryDays')" show-overflow-tooltip width="90">
        <template slot-scope="scope">
          {{ scope.row.delivery_date ? scope.row.delivery_date : '-' }}
        </template>
      </el-table-column>
      <el-table-column v-if="showSystemCode" prop="system_code" label="系统编码" show-overflow-tooltip width="100"></el-table-column>
      <el-table-column prop="money2" :label="$t('order.free.residentialFee')" show-overflow-tooltip width="70">
        <template slot-scope="scope">
          {{ fmtMoney(scope.row.money2) }}
        </template>
      </el-table-column>
      <el-table-column prop="money3" :label="$t('order.free.ahsFee')" show-overflow-tooltip width="70">
        <template slot-scope="scope">
          {{ fmtMoney(scope.row.money3) }}
        </template>
      </el-table-column>
      <el-table-column prop="money4" :label="$t('order.free.osFee')" show-overflow-tooltip width="70">
        <template slot-scope="scope">
          {{ fmtMoney(scope.row.money4) }}
        </template>
      </el-table-column>
      <el-table-column prop="q_money" :label="$t('order.free.pickupFee')" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          {{ fmtMoney(scope.row.q_money) }}
        </template>
      </el-table-column>
      <el-table-column prop="money5" :label="$t('order.free.otherFee')" show-overflow-tooltip></el-table-column>
    </el-table>
    <div class="free-bot">
      <div class="free-title">{{ $t('order.free.bestPrice') }}<span style="color: #F56C6C;">{{ freeInfo.first_service }}</span></div>
      <div class="free-money">{{ $t('order.free.rmbExchange') }}<span style="color: #F56C6C;">{{ freeInfo.first_money.toFixed(2) }} CNY/{{ freeInfo.pa_unit }}</span></div>
    </div>
    <div class="free-btn">
      <el-button type="primary" @click="handleRates" size='small'>{{ $t('order.free.confirmBtn') }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    freeInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
       currentRow: '',
    };
  },
  computed: {
    // 判断是否显示系统编码列：只要列表中有任意一条 system_code 非空就显示
    showSystemCode() {
      const list = this.freeInfo.money_list || []
      return list.some(item => item.system_code && item.system_code !== '')
    }
  },
  methods: {
    // 金额格式化：非有效数字（undefined/null/NaN）时显示 "-"，否则保留两位小数
    fmtMoney(val) {
      const num = Number(val)
      return Number.isFinite(num) ? num.toFixed(2) : '-'
    },
    // 判断是否为报价失败行（价格为0且有报错信息，但不是"该渠道服务不支持"那种已合并处理的行）
    isFailedRow(row) {
      const notSupport = this.$t('order.free.serviceNotSupport')
      return Number(row.all_money) === 0 && row.msg && row.msg !== notSupport
    },
    // 点击确定按钮
    handleRates(){
      this.$emit('getRatesInfo',this.currentRow)
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // 选择(0)、序号(1) 不参与合并，其余列在"不支持"时合并
      if (columnIndex >= 2) {
        if (row.msg === this.$t('order.free.serviceNotSupport')) {
          // 总列数：不含系统编码时13列，含系统编码时14列
          const totalCols = this.showSystemCode ? 14 : 13
          if (columnIndex === 2) {
            return {
              rowspan: 1,
              colspan: totalCols - 2
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1
          };
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.pagization-box {
  overflow: hidden;
  margin-top: 10px;

  .el-pagination {
    float: right;
  }
}
::v-deep {
  .el-table {
    thead {
      color: #fff;
      font-weight: 500;
      background: #f5f7fa;
      color: #606266;
      white-space: nowrap;
      & th {
        background-color: transparent;
      }
      & tr {
        background-color: transparent;
      }
    }
  }
}
.hidden-label-radio /deep/.el-radio__label {
  display: none;
}
.free-bot{
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
  .free-title{
    font-size: 14px;
    color: #999;
  }
  .free-money{
    font-size: 14px;
    color: #999;
  }
}
.free-btn{
  display: flex;
  justify-content: flex-end;
  margin: 10px 0 0 0;
}
.free-fail-icon{
  color: #F56C6C;
  margin-left: 5px;
  cursor: pointer;
  font-size: 15px;
  vertical-align: middle;
}
</style>

<style lang="scss">
/* 非 scoped：el-popover 内容会渲染到 body 下，需全局样式 */
.free-fail-popover {
  .free-fail-title {
    font-weight: 600;
    color: #F56C6C;
    margin-bottom: 6px;
    font-size: 13px;
  }
  .free-fail-content {
    color: #606266;
    font-size: 13px;
    line-height: 1.6;
    text-align: left;
    white-space: normal;
    word-break: break-word;
    max-height: 240px;
    overflow-y: auto;
  }
}
</style>
